import * as React from 'react';
import { BodyWithMenu } from '../../components/organisms/Menu';
import { TranslatedTerms } from '../../globals/TranslatedTerms';
import { createEnDaContent, lang, translateContent } from '../../globals/Translations';
import { useWindowSize } from '../../globals/UIHooks';
import FeedCard from '../../components/atoms/FeedCard';
import SubscriptionList from '../../components/molecules/SubscriptionList';
import Investor from '../../shared/Investor';
import { getFeed } from '../../globals/ApiHooks';
import { showError } from '../../globals/ErrorLib';
import Post, { Channel } from '../../shared/Post';
import AnalyticsHooks from '../../globals/AnalyticsHooks';
import { ActivityType } from '../../shared/Activity';

export const SubList = (defaultChannels: Channel[], projectChannels: Channel[], investor: Investor) => (
  <div style={{ width: 400, margin: 'auto', marginTop: 0 }}>
    <SubscriptionList projectChannels={projectChannels} defaultChannels={defaultChannels}
      investorId={investor.investorId} investorChannels={investor.channels} />
  </div>
)

const PAGE_LENGTH = 10
export const PostList: React.FC<{ posts: Post[] }> = ({ posts }) => {
  const [postInView, setPostInView] = React.useState<Post[]>([])
  const [index, setIndex] = React.useState<number>(PAGE_LENGTH)

  React.useEffect(() => {
    setPostInView(posts.slice(0, index))
  }, [index, posts])

  const loadMoreLabel = lang(translateContent(createEnDaContent("Load more", "Hent flere")))
  const showLoadMore = posts.length > 0 && index < posts.length
  return (
    <div style={{ display: 'flex', flexDirection: 'column', maxWidth: 600, margin: 'auto', height: '100%' }}>
      {postInView.map((item, key) => <FeedCard post={item} key={key} />)}
      {showLoadMore && <button style={{ marginTop: 20 }} onClick={() => setIndex((old) => old + PAGE_LENGTH)}>{loadMoreLabel}</button>}
    </div>
  )
}


export const FeedPage: React.FC = () => {
  const [loading, setLoading] = React.useState<boolean>(false)
  const [investor, setInvestor] = React.useState<Investor>()
  const [posts, setPosts] = React.useState<Post[]>([])

  const [projectChannels, setProjectChannels] = React.useState<Channel[]>()
  const [defaultChannels, setDefaultChannels] = React.useState<Channel[]>()
  const [showChannels, setShowChannels] = React.useState<boolean>(false)


  React.useEffect(() => {
    (async () => {
      if (loading) return
      setLoading(true)
      const result = await getFeed()
      if (!result) return showError("Can't get your feed")
      setInvestor(result.investor)
      setPosts(result.posts)
      setDefaultChannels(result.defaultChannels)
      setProjectChannels(result.projectChannels)
      setLoading(false)
    })()
  }, [])

  const { width } = useWindowSize()

  const small = width && width < 1300

  const showChannelsLabel = lang(translateContent(createEnDaContent("Show channels", "Vis kanaler")))
  const hideChannelsLabel = lang(translateContent(createEnDaContent("Hide channels", "Skjul kanaler")))
  AnalyticsHooks.LogActivity(ActivityType.FEED_VISIT)
  return (
    <BodyWithMenu loading={loading}>
      <h1>{lang(TranslatedTerms.FEED)}</h1>
      {small && (
        <div style={{ display: 'flex', marginBottom: 20, flexDirection: 'row-reverse' }}>
          <button onClick={() => setShowChannels(!showChannels)}>{showChannels ? hideChannelsLabel : showChannelsLabel}</button>
        </div>
      )}
      <div style={{
        display: 'grid', gridTemplateColumns: small ? "1fr" : "2fr 1fr",
        gridColumnGap: 0, gridRowGap: 20, gridRow: 1
      }}>
        {projectChannels && defaultChannels && investor && small && showChannels && SubList(defaultChannels, projectChannels, investor)}

        <PostList posts={posts} />
        {projectChannels && defaultChannels && investor && !small && SubList(defaultChannels, projectChannels, investor)}
      </div>
    </BodyWithMenu>
  )
};
